import { Mountain } from "lucide-react";
import React from "react";

// The six partner levels (highest first). Sponsors are tagged with `id`; no dollar amounts are ever shown on sponsor cards.
export const SPONSOR_LEVELS = [
    { id: "pyramid-peak", label: "Pyramid Peak Partner" },
    { id: "crescent-peak", label: "Crescent Peak Partner" },
    { id: "devine-peak", label: "Devine Peak Partner" },
    { id: "marshall-mountain", label: "Marshall Mountain Partner" },
    { id: "rice-ridge", label: "Rice Ridge Partner" },
    { id: "big-gus", label: "Big Gus Partner" },
];
export const FEATURED_LEVEL_IDS = ["pyramid-peak", "crescent-peak"];
export const levelLabel = (id) => SPONSOR_LEVELS.find(l => l.id === id)?.label || "Community Partner";
export const levelRank = (id) => { const i = SPONSOR_LEVELS.findIndex(l => l.id === id); return i === -1 ? 99 : i; };

export const LevelBadge = ({ level, large = false, testId }) => (
    <span data-testid={testId}
        className={`inline-flex items-center gap-1.5 bg-[#C9A84C] text-[#3D2008] font-manrope font-bold uppercase tracking-wide rounded-full border border-[#3D2008]/30 ${large ? "text-xs px-3 py-1.5" : "text-[11px] px-2.5 py-1"}`}>
        <Mountain size={large ? 14 : 12} /> {levelLabel(level)}
    </span>
);
